import React, { lazy, Suspense, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";

import Loader from "./Components/Loader";
import NotFound from "./Components/NotFound/NotFound";
import OAuthSuccess from "./utils/OAuthSuccess";
import OAuthGoogleSignup from "./Pages/Auth/Signup/OAuthGoogleSignup";
import LogRocketInit from "./analytics/log-rocket-init";

const Home = lazy(() => import("./Pages/Home/Home"));
const Login = lazy(() => import("./Pages/Auth/Login/Login"));
const Signup = lazy(() => import("./Pages/Auth/Signup/Signup"));
const AppDrawerNav = lazy(() => import("./Pages/CreateNewBot/AppDrawerNav"));
const ChatInterface = lazy(() => import("./Pages/HtmlEmbeds/ChatInterface"));

function App() {
  const isProduction = process.env.NODE_ENV === "production";

  // Adding Google Analytics on production
  useEffect(() => {
    if (isProduction) {
      console.log(isProduction);
      const script = document.createElement("script");
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-6CP3RDL9HK";
      script.async = true;
      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }
        gtag("js", new Date());
        gtag("config", "G-6CP3RDL9HK");
      };
    }
  }, [isProduction]);

  return (
    <div>
      <Router>
        <Suspense fallback={<Loader />}>
          <LogRocketInit />

          <Routes>
            <Route path="/" element={<Home />} />

            <Route path="/auth/login" element={<Login />} />
            <Route path="/auth/signup" element={<Signup />} />
            <Route path="/dashboard/*" element={<AppDrawerNav />} />
            <Route path="/chat-interface" element={<ChatInterface />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/oauth-success" element={<OAuthSuccess />} />
            <Route
              path="/oauth-google-signup"
              element={<OAuthGoogleSignup />}
            />
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
